import { IApplicationState } from '../../types/redux';
import { ENewReviewFlow } from '../../types/newReview';

export const getNewReviewFlow = (state: IApplicationState): ENewReviewFlow | null => {
  return state.newReview.meta.flow;
};
